import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UrlService {
  encode(text: string): string {
    return encodeURIComponent(text);
  }

  logoHeight(width: number): number {
    return Math.round((width * 612) / 2189);
  }

  parsePublicId(url: string): string {
    const splitted = url.split('/');
    return splitted[splitted.length - 1];
  }
}
